module.exports = __webpack_public_path__ + "img/client7.ad213de6.png";